import { useEffect, useRef } from "react";
import { Search } from "lucide-react";

/** Barra di ricerca sempre visibile in cima agli elenchi su mobile. */
export function RicercaMobile({ valore, onChange, placeholder, testId }) {
  return (
    <div className="sm:hidden sticky top-[7.5rem] z-10 -mx-4 px-4 py-2 bg-[#F8F9FA]/95 backdrop-blur">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input value={valore} onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
          data-testid={testId}
          className="w-full rounded-full border border-slate-200 bg-white pl-9 pr-3 py-2 text-sm
            focus:outline-none focus:ring-2 focus:ring-sky-300 transition-colors duration-200" />
      </div>
    </div>
  );
}

/** Sentinella per il caricamento automatico della pagina successiva. */
export function ScrollInfinito({ onAltro, attivo, caricando }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!attivo || !ref.current) return undefined;
    const obs = new IntersectionObserver((voci) => {
      if (voci[0].isIntersecting) onAltro();
    }, { rootMargin: "200px" });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [attivo, onAltro]);
  return (
    <div ref={ref} className="py-4 text-center text-xs text-slate-400" data-testid="scroll-infinito">
      {attivo ? (caricando ? "Caricamento…" : "Scorri per altri risultati") : "Fine dei risultati"}
    </div>
  );
}
